import '../scss/app.scss'

document.addEventListener('DOMContentLoaded', function () {
    const tabsNavs = document.querySelectorAll('.product__tabs-nav');
    const tabsNavsMobile = document.querySelectorAll('.product__tabs-nav__mobile');
    const tabsContent = document.querySelectorAll('.product__tabs-item');

    if (tabsNavs.length > 0 && tabsContent.length > 0 && tabsNavsMobile.length > 0) {
        tabsNavs.forEach((nav, index) => {
            nav.addEventListener('click', function (e) {
                e.preventDefault();

                tabsNavs.forEach(nav => nav.classList.remove('active'));
                tabsContent.forEach(content => content.classList.remove('active'));

                nav.classList.add('active');
                tabsContent[index].classList.add('active');
            });
        });

        tabsNavs[0].classList.add('active');
        tabsContent[0].classList.add('active');

        tabsNavsMobile.forEach((nav, index) => {
            nav.addEventListener('click', function (e) {
                e.preventDefault();

                if (nav.classList.contains('active')) {
                    nav.classList.remove('active');
                    tabsContent[index].classList.remove('active');
                } else {

                    tabsNavsMobile.forEach(nav => nav.classList.remove('active'));
                    tabsContent.forEach(content => content.classList.remove('active'));

                    nav.classList.add('active');
                    tabsContent[index].classList.add('active');
                }
            });
        });

        tabsNavsMobile[0].classList.add('active');
        tabsContent[0].classList.add('active');
    }
});

let burger = document.querySelectorAll('.get__header-burger');
const menuMobile = document.querySelector('.get__header-menu__mobile');
const headerMain = document.querySelector('.get__header-wrapper--main');
const body = document.querySelector('html');

burger.forEach((el) => {
    el.addEventListener('click', () => {
        el.classList.toggle('activated');
        menuMobile.classList.toggle('activated');
        body.classList.toggle('no-scroll');
        if (headerMain) {
            headerMain.classList.toggle('activated');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu__mobile .menu-item-has-children');
    menuItems.forEach(item => {
        const toggle = item.querySelector('.submenu-toggle');

        if (toggle) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const subMenuWrapper = item.querySelector('.sub-menu__wrapper');
                console.log(subMenuWrapper)
                if (subMenuWrapper) {
                    toggle.classList.toggle('activated');
                    subMenuWrapper.classList.toggle('activated');
                    item.classList.toggle('activated');
                }
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const searchBtn = document.getElementById('searchBtn');
    const searchWrapper = document.getElementById('searchWrapper');
    const menuWrapper = document.getElementById('menuWrapper');
    const searchShow = document.getElementById('searchShow');
    if (searchBtn && searchWrapper && menuWrapper && searchShow) {
        searchBtn.addEventListener('click', function () {
            searchShow.classList.toggle('activated');
            searchWrapper.classList.toggle('activated');
            menuWrapper.classList.toggle('disabled');
        });
    }
});

// tevitta
document.addEventListener('DOMContentLoaded', function () {
    const openSort = document.getElementById('openSort');
    const dropSort = document.getElementById('dropSort');
    const blockSort = document.getElementById('blockSort');
    if (openSort && dropSort && blockSort) {
        openSort.addEventListener('click', function (e) {
            e.preventDefault();
            dropSort.classList.toggle('activated');
            blockSort.classList.toggle('activated');
        });
    }
});

document.querySelectorAll('.single__product-accordion__title').forEach(function (title) {
    title.addEventListener('click', function () {
        var content = this.nextElementSibling; // Получаем контент блока
        var icon = this.querySelector('.accordion-icon'); // Иконка состояния

        // Проверяем текущее состояние контента
        if (content.style.display === "block") {
            content.style.display = "none"; // Скрываем контент
            icon.classList.remove('open'); // Меняем иконку на "+"
        } else {
            content.style.display = "block"; // Отображаем контент
            icon.classList.add('open'); // Меняем иконку на "×"
        }
    });
});

var swiper = new Swiper(".sp__slider", {
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".sbn",
        prevEl: ".sbp",
    },
    spaceBetween: 30,
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: false,
            translate: ["-20%", 0, -1],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
});

var mainPost = new Swiper(".similar__posts", {
    slidesPerView: 3,
    spaceBetween: 24,
    breakpoints: {
        320: {
            spaceBetween: 12,
            slidesPerView: 1.25,
        },
        576: {
            spaceBetween: 24,
            slidesPerView: 1.25,
        },
        992: {
            spaceBetween: 24,
            slidesPerView: 3,
        },
    },
});


// var similarPost = new Swiper(".similar__posts", {
//     slidesPerView: 3,
//     spaceBetween: 30,
// });

var marque = new Swiper(".t__marquee", {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
        delay: 1,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true
});

document.querySelectorAll('.vacancies__item').forEach(function (vacancies) {
    vacancies.addEventListener('click', function () {
        var content = this.nextElementSibling; // Получаем контент блока

        // Проверяем текущее состояние контента
        if (content.style.display === "block") {
            vacancies.classList.toggle('active');
            content.style.display = "none"; // Скрываем контент
        } else {
            vacancies.classList.toggle('active');
            content.style.display = "block"; // Отображаем контент
        }
    });
})

if (window.innerWidth < 992) {
    var mainPost = new Swiper(".main__posts", {
        slidesPerView: 1.25,
        spaceBetween: 24,
        breakpoints: {
            320: {
                spaceBetween: 12,
            },
            576: {
                spaceBetween: 24,
            },
        },
    });
}


document.addEventListener("DOMContentLoaded", function () {
    const footer = document.querySelector(".get__footer-wrapper");
    const main = document.querySelector(".footer__bg");

    function adjustMainPadding() {
        const footerHeight = footer.offsetHeight;
        main.style.paddingBottom = `${footerHeight}px`;
    }

    function adjustFooterOpacity() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrolledDistance = window.scrollY;
        const remainingDistance = scrollableHeight - scrolledDistance;
        const opacity = Math.min(1, Math.max(0, 1 - remainingDistance / 300));

        footer.style.opacity = opacity;
    }

    adjustMainPadding();
    adjustFooterOpacity();

    window.addEventListener("resize", adjustMainPadding);
    window.addEventListener("scroll", adjustFooterOpacity);
});

document.querySelectorAll('.get__footer-menu__title').forEach(function (title) {
    title.addEventListener('click', function () {

        document.querySelectorAll('.get__footer-menu__title').forEach(function (otherTitle) {
            if (otherTitle !== title) {
                otherTitle.parentElement.classList.remove('active');
            }
        });

        let parent = this.parentElement;
        parent.classList.toggle('active');

        function adjustMainPadding() {
            const footerHeight = document.querySelector(".get__footer-wrapper").offsetHeight;
            document.querySelector(".footer__bg").style.paddingBottom = `${footerHeight}px`;
        }

        adjustMainPadding()
    });
});

// Initial padding adjustment


document.querySelectorAll('.sap__item-title').forEach(function (title) {
    title.addEventListener('click', function () {
        let parent = this.parentElement;
        parent.classList.toggle('active');
    });
});


var sacsLinks = new Swiper(".sacs__links-mobile", {
    slidesPerView: 2,
    spaceBetween: 24,
    breakpoints: {
        320: {
            spaceBetween: 12,
        },
        576: {
            spaceBetween: 24,
        },
    },
});


//map

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.map svg g.collaborated').forEach(function (mapButton) {
        mapButton.addEventListener('click', function () {
            const mapInfo = document.querySelector('.map__info');
            const isAlreadyActivated = this.classList.contains('activated');

            document.querySelectorAll('.map svg g.collaborated').forEach(function (tab) {
                tab.classList.remove('activated');
                mapInfo.classList.remove('activated');
            });
            document.querySelectorAll('.map__info-region').forEach(function (content) {
                content.classList.remove('activated');
                mapInfo.classList.remove('activated');
            });

            if (isAlreadyActivated) return;

            let mapId = this.getAttribute('data-region');
            document.getElementById(mapId).classList.add('activated');
            this.classList.toggle('activated');
            mapInfo.classList.toggle('activated');
        });
    });
});

const swiperContainer = document.querySelector(".private-label");

// Проверяем количество слайдов
if (swiperContainer) {
    const slides = swiperContainer.querySelectorAll(".swiper-slide");
    const slidesCount = slides.length;

    const privateLabel = new Swiper(".private-label", {
        slidesPerView: slidesCount > 3 ? 3.2 : 3,
        spaceBetween: 24,
        breakpoints: {
            320: {
                spaceBetween: 12,
                slidesPerView: slidesCount > 3 ? 1.1 : 1.25,
            },
            576: {
                spaceBetween: 24,
                slidesPerView: slidesCount > 3 ? 2.2 : 1.25,
            },
            992: {
                spaceBetween: 24,
                slidesPerView: slidesCount > 3 ? 3.2 : 3,
            },
        },
    });
}


// menu

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll('.menu-item-has-children').forEach(function (menuItem) {
//         menuItem.addEventListener('mouseenter', function () {
//             this.classList.add('hovered'); // добавляем класс для показа подменю
//
//         });
//         menuItem.addEventListener('mouseleave', function () {
//             this.classList.remove('hovered'); // убираем класс при уходе мыши
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', () => {
    const menuItem = document.querySelector('.menu__desktop .menu-item-has-children');
    const subMenu = menuItem.querySelector('.sub-menu__wrapper');
    const headerChange = document.querySelector('.get__header-wrapper--main');
    let timeoutId;

    // Создаем невидимую зону для предотвращения "мерцания"
    const createHoverZone = () => {
        const hoverZone = document.createElement('div');
        hoverZone.style.position = 'absolute';
        hoverZone.style.width = '100%';
        hoverZone.style.height = '80px'; // Высота промежутка
        hoverZone.style.top = '85%';
        hoverZone.style.left = '0';
        hoverZone.style.pointerEvents = 'none'; // Чтобы зона не мешала взаимодействию
        return hoverZone;
    };

    const hoverZone = createHoverZone();
    menuItem.appendChild(hoverZone);

    const showSubmenu = () => {
        clearTimeout(timeoutId);
        subMenu.style.display = 'flex';
        subMenu.style.opacity = '1';
        subMenu.style.visibility = 'visible';
        headerChange.classList.add('ghd');
    };

    const hideSubmenu = () => {
        timeoutId = setTimeout(() => {
            subMenu.style.opacity = '0';
            subMenu.style.visibility = 'hidden';
            headerChange.classList.remove('ghd');
            // После завершения анимации скрываем меню полностью
            setTimeout(() => {
                if (subMenu.style.visibility === 'hidden') {
                    subMenu.style.display = 'none';
                }
            }, 300); // Время должно совпадать с CSS transition
        }, 100);
    };

    menuItem.addEventListener('mouseenter', showSubmenu);
    subMenu.addEventListener('mouseenter', showSubmenu);

    menuItem.addEventListener('mouseleave', (e) => {
        // Проверяем, не навел ли пользователь на подменю
        const toElement = e.relatedTarget;
        if (!subMenu.contains(toElement)) {
            hideSubmenu();
        }
    });

    subMenu.addEventListener('mouseleave', hideSubmenu);
});

// document.addEventListener('DOMContentLoaded', () => {
//     const menuItems = document.querySelectorAll('.sub-menu li a');
//     const subMenuImage = document.querySelector('.sub-menu__image img');
//
//     menuItems.forEach(item => {
//         item.addEventListener('mouseenter', (e) => {
//             const imageUrl = e.target.getAttribute('data-img');
//             subMenuImage.src = imageUrl;
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.sub-menu li a');
    const subMenuImage = document.querySelector('.sub-menu__image img');

    // Установка первого изображения по умолчанию
    const firstImageUrl = menuItems[0].getAttribute('data-img');
    subMenuImage.src = firstImageUrl;

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', (e) => {
            const imageUrl = e.target.getAttribute('data-img');
            subMenuImage.src = imageUrl;
        });
    });
});
